import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'form-wrapper',
    templateUrl: './form-wrapper.component.html',
    styleUrls: ['./form-wrapper.component.scss'],
    standalone: false
})
export class FormWrapperComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
